<div id="modal-container">
  <table id="search-add-tbl">
    <tr style="height: fit-content">
      <th class="search">
        <app-ticker-search
          [isComp]="true"
          [isTickerTypeBg]="isTickerTypeBg"
          (tickerToEmit)="addSearchedTicker($event)"
        ></app-ticker-search>
      </th>
      <th>Selected Companies (up to {{ maxTickers }}):</th>
    </tr>
    <tr>
      <td class="add">
        <div class="content-heading">
          <div
            class="left-heading"
            [style.visibility]="watchlistData.length ? 'visible' : 'hidden'"
          >
            <div
              nz-dropdown
              nzTrigger="click"
              [nzDropdownMenu]="menu"
              [ngClass]="{ active: visible }"
              (nzVisibleChange)="onMenuVisibleChange($event)"
              [nzOverlayClassName]="'comp-menu-dropdown'"
              [nzBackdrop]="false"
              id="selectedItem"
            >
              {{ selectedMenuItem }}
              <i nz-icon nzType="down" style="float: right"></i>
            </div>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu class="menu-holder">
                <li
                  nz-menu-item
                  *ngFor="let data of watchlistData"
                  (click)="onWatchlistSelect($event, data)"
                  [title]="data.watchername"
                  style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >
                  {{ data.watchername }}
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
          <div class="right-heading-add" (click)="addAllTickers()">
            <va-icon size="small" name="plus" class="icon va-icon"></va-icon>Add
            All
          </div>
        </div>
        <!-- <div class="recently-visited-list ticker-list">
              <div class="company" *ngFor="let comp of recentlyVisited">
                <va-icon
                  name="comp.isSelected ? faCheck : faPlus"
                  class="add-comp"
                  (click)="addTicker(comp, false)"
                ></va-icon
                >
                {{ comp.name }}
              </div>
            </div> -->
        <app-add-modal-section
          [dataToUse]="recentlyVisited"
          field="full_name"
          company="ticker"
          (addData)="addTicker($event)"
          [maxHeight]="maxHeight"
        ></app-add-modal-section>
      </td>
      <td class="add">
        <div class="content-heading">
          <div
            class="left-heading"
            [style.color]="
              modalData.length > maxTickers || modalData.length < 1
                ? '#e61F00'
                : '#363636'
            "
          >
            Number of selected: {{ modalData && modalData.length }}
          </div>
          <div
            [ngClass]="[
              modalData && modalData.length
                ? 'right-heading-remove'
                : 'greyed-removeall'
            ]"
            (click)="removeAllTickers()"
          >
            <va-icon size="small" name="close" class="icon va-icon"></va-icon
            >Remove All
          </div>
        </div>
        <app-remove-modal-section
          [dataToUse]="modalData"
          field="full_name"
          company="ticker"
          [maxHeight]="maxHeight"
          (removeData)="removeTicker($event)"
        ></app-remove-modal-section>
      </td>
    </tr>
  </table>

  <!-- <div *nzModalFooter>
    <button nz-button nzType="default" (click)="destroyModal()">Cancel</button>
    <button
      nz-button
      nzType="primary"
      [nzLoading]="isLoading"
      [disabled]="this.modalData.length > 50 ? true : false"
      (click)="updateLineItems()"
    >
      Update
    </button>
  </div> -->
</div>
